import plyr from './modules/plyr';

$(function() {
	plyr.init();	
})